export default {
  newsfeedTimestamp(state) {
    return state.newsfeedTimestamp;
  },
  posts(state) {
    return state.posts;
  },
};
